'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "When should I consider redesigning my website?",
    answer: "If your website looks outdated, loads slowly, isn't mobile-friendly, or doesn't convert visitors into customers effectively, it's time for a redesign. A modern website improves user experience, trust, and business results."
  },
  {
    question: "What’s included in a website redesign and modernization project?",
    answer: "Our service includes UI/UX enhancements, responsive redesign, faster load speeds, updated visuals, content restructuring, and integration of modern technologies — all aimed at improving performance and engagement."
  },
  {
    question: "Will my website be down during the redesign process?",
    answer: "No. We build your new site on a staging environment, so your current website stays live and unaffected until the new version is ready to launch — ensuring zero downtime during development."
  },
  {
    question: "Can you redesign my site without changing my existing content?",
    answer: "Yes. We can retain your current content and simply present it in a more modern, user-friendly, and responsive layout. We also offer content refinement if you’re looking to update or improve messaging."
  },
  {
    question: "Will the new website be SEO and performance optimized?",
    answer: "Absolutely. All redesigns include on-page SEO best practices, speed optimizations, accessibility improvements, and mobile responsiveness to ensure your site performs well across devices and search engines."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div
        className="col text-center py-5 mt-5"
        data-aos="fade-up"
        data-aos-delay="100"
        data-aos-duration="500"
        data-aos-once="true"
      >
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div
          className="container"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-duration="500"
          data-aos-once="true"
        >
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level={3}
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <span
  className={`transition-colors duration-200 cursor-pointer 
    hover:text-purple-600 
    ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
>{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
